import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Crop"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 15H17.25V6.75H9V5.25H17.25C18.0784 5.25 18.75 5.92157 18.75 6.75V15ZM6.75 17.25V1.5H5.25V5.25H1.5V6.75H5.25V17.25C5.25 18.0784 5.92157 18.75 6.75 18.75H17.25V22.5H18.75V18.75H22.5V17.25H6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Crop.vue"]]);
